import Vue from 'vue'
import Router from 'vue-router'

/*--- PUBLIC ---*/
import Home from '@/components/public/Home'
import Privacy from '@/components/public/Privacy'
import Support from '@/components/public/Support'
import Contribute from '@/components/public/Contribute'
import Terms from '@/components/public/Terms'

/*--- AUTH ---*/
import Login from '@/components/auth/Login'
import Signup from '@/components/auth/Signup'
import Profile from '@/components/auth/Profile'

/*--- ADMIN ---*/
import AdminDashboard from '@/components/admin/AdminDashboard'
import Recipes from '@/components/admin/recipes/Recipes'
import AddEditRecipe from '@/components/admin/recipes/AddEditRecipe'

/*--- MANAGER ---*/
import ManagerDashboard from '@/components/admin/ManagerDashboard'

/*--- AUTHOR ---*/
import AuthorDashboard from '@/components/admin/AuthorDashboard'

/*--- MEMBER ---*/
import MemberDashboard from '@/components/member/MemberDashboard'
import Subscription from '@/components/member/subscriptions/Subscription'

import Newsfeed from '@/components/member/newsfeed/Newsfeed'

import EventsList from '@/components/member/events/EventsList'
import EventsDetail from '@/components/member/events/EventsDetail'
import CreateEvent from '@/components/member/events/CreateEvent'

import DiscussionsList from '@/components/member/discussions/DiscussionsList'
import DiscussionsDetail from '@/components/member/discussions/DiscussionsDetail'

import MembersList from '@/components/member/members/MembersList'
import MembersDetail from '@/components/member/members/MembersDetail'

import RecipeboxList from '@/components/member/recipes/RecipeboxList'
import RecipeBoxDetail from '@/components/member/recipes/RecipeboxDetail'

import VideosList from '@/components/member/videos/VideosList'
import VideosDetail from '@/components/member/videos/VideosDetail'

import PodcastsList from '@/components/member/podcasts/PodcastsList'
import PodcastsDetail from '@/components/member/podcasts/PodcastsDetail'

import StoriesList from '@/components/member/stories/StoriesList'
import StoriesDetail from '@/components/member/stories/StoriesDetail'

import BooksList from '@/components/member/books/BooksList'
import BooksDetail from '@/components/member/books/BooksDetail'

import MemberProfile from '@/components/member/profile/MemberProfile'

import { store } from '../store/store.js';

import Vuex from 'vuex'
Vue.use(Router)
Vue.use(Vuex)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    }
    next('/login')
}

const router = new Router({
    mode: 'history',
    routes: [

        // Public
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/signup',
            name: 'Signup',
            component: Signup,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/',
            name: 'Home',
            component: (!store.getters.isAuthenticated)? Home : Recipes
        },
        {
            path: '/terms',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        },
        {
            path: '/support',
            name: 'Support',
            component: Support
        },
        {
            path: '/contribute',
            name: 'Contribute',
            component: Contribute
        },
        
        // Admin
        {
            path: '/admin-dashboard',
            name: 'AdminDashboard',
            component: AdminDashboard,
            beforeEnter: ifAuthenticated
        },
        {
          path: '/recipes',
          name: 'Recipes',
          component: Recipes,
          beforeEnter: ifAuthenticated
        },
        {
          path: '/addRecipe',
          name: 'AddRecipe',
          component: AddEditRecipe,
          beforeEnter: ifAuthenticated
        },
        {
          path: '/recipe/:id',
          name: 'EditRecipe',
          props: true,
          component: AddEditRecipe,
          beforeEnter: ifAuthenticated
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile,
          beforeEnter: ifAuthenticated
        },

        // Manager
        {
            path: '/manager-dashboard',
            name: 'ManagerDashboard',
            component: ManagerDashboard,
            beforeEnter: ifAuthenticated
        },  
        
        // Author
        {
            path: '/author-dashboard',
            name: 'AuthorDashboard',
            component: AuthorDashboard,
            beforeEnter: ifAuthenticated
        },        

        // Member                
        {
            path: '/newsfeed',
            name: 'Newsfeed',
            component: Newsfeed,
            beforeEnter: ifAuthenticated
        },        
        {
            path: '/events',
            name: 'EventsList',
            component: EventsList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/events-detail/:id',
            name: 'EventsDetail',
            props: true,
            component: EventsDetail,
            beforeEnter: ifAuthenticated
        },        
        {
            path: '/create-event',
            name: 'CreateEvent',
            props: true,
            component: CreateEvent,
            beforeEnter: ifAuthenticated
        },    
        {
            path: '/event/:id',
            name: 'EditEvent',
            props: true,
            component: CreateEvent,
            beforeEnter: ifAuthenticated
        },    
        {
            path: '/discussions',
            name: 'DiscussionsList',
            component: DiscussionsList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/discussions-detail',
            name: 'DiscussionDetail',
            component: DiscussionsDetail,
            beforeEnter: ifAuthenticated
        },               
        {
            path: '/members',
            name: 'MembersList',
            component: MembersList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/members-detail/:id',
            name: 'MembersDetail',
            props: true,
            component: MembersDetail,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/recipebox',
            name: 'RecipeboxList',
            component: RecipeboxList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/recipebox-detail',
            name: 'RecipeBoxDetail',
            component: RecipeBoxDetail,
            beforeEnter: ifAuthenticated
        },        
        {
            path: '/videos',
            name: 'VideosList',
            component: VideosList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/videos-detail',
            name: 'VideosDetail',
            component: VideosDetail,
            beforeEnter: ifAuthenticated
        },        
        {
            path: '/podcasts',
            name: 'PodcastsList',
            component: PodcastsList,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/podcasts-detail',
            name: 'PodcastsDetail',
            component: PodcastsDetail,
            beforeEnter: ifAuthenticated
        },             
        {
            path: '/stories',
            name: 'StoriesList',
            component: StoriesList,
            beforeEnter: ifAuthenticated
        },  
        {
            path: '/stories-detail',
            name: 'StoriesDetail',
            component: StoriesDetail,
            beforeEnter: ifAuthenticated
        },               
        {
            path: '/books',
            name: 'BooksList',
            component: BooksList,
            beforeEnter: ifAuthenticated
        },   
        {
            path: '/books-detail',
            name: 'BooksDetail',
            component: BooksDetail,
            beforeEnter: ifAuthenticated
        },        
        {
            path: '/member-profile',
            name: 'MemberProfile',
            component: MemberProfile,
            beforeEnter: ifAuthenticated
        },              
        {
            path: '/member-dashboard',
            name: 'MemberDashboard',
            component: MemberDashboard,
            beforeEnter: ifAuthenticated
        },              
        {
            path: '/subscription',
            name: 'Subscription',
            component: Subscription,
            beforeEnter: ifAuthenticated
        },              

        // Common
        {
            path: '/',
            redirect: 'home'
        },
        {
            path: '*',
            redirect: 'home'
        }
    ]
})

export default router;